if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();

        // Hydrate all modal images so mobile swipe/scroll never shows blanks
        this.hydrateAllMedia();
      }

      hydrateAllMedia() {
        // Hydrate any deferred modal images (your product-media.liquid uses data-src/data-srcset)
        this.querySelectorAll('img[data-src], img[data-srcset]').forEach((img) => this.hydrateMedia(img));
      }

      hydrateMedia(mediaEl) {
        if (!mediaEl) return;

        // In your theme, data-media-id can be on the img itself (modal content),
        // so handle both "img is the element" and "img inside element".
        const img =
          mediaEl.matches && mediaEl.matches('img')
            ? mediaEl
            : mediaEl.querySelector
              ? mediaEl.querySelector('img[data-src], img[data-srcset]')
              : null;

        if (!img) return;

        // Do not run twice for the same image
        if (img.dataset.hydrated === 'true') return;

        const dataSrc = img.getAttribute('data-src');
        const dataSrcset = img.getAttribute('data-srcset');
        const dataSizes = img.getAttribute('data-sizes');

        if (dataSrcset) img.setAttribute('srcset', dataSrcset.trim());
        if (dataSizes) img.setAttribute('sizes', dataSizes);
        if (dataSrc) img.setAttribute('src', dataSrc);

        // Clean up so it cannot get reprocessed in weird editor states
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
        img.removeAttribute('data-sizes');

        img.dataset.hydrated = 'true';
      }

      showActiveMedia() {
        const openedByMediaId = this.openedBy?.getAttribute('data-media-id');

        this.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.toggle('active', element.getAttribute('data-media-id') === openedByMediaId);
        });

        const activeMedia = this.querySelector(`[data-media-id="${openedByMediaId}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector ? activeMedia.querySelector('template') : null;
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        activeMedia.scrollIntoView();

        // Hydrate the active media first (works whether activeMedia is the img itself or a wrapper)
        this.hydrateMedia(activeMedia);

        const container = this.querySelector('[role="document"]');
        if (container) container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}